import getWindow from "./window";

export const handleModalTriggerEvent = ({
  focusOnCloseElement,
  position = null,
  eventKey,
  data,
}) => {
  getWindow().asos.eventBus.emit(eventKey, {
    focusOnCloseElement,
    position,
    data,
  });
};
